<template>
  <section class="page-surgeon-form">
    <breadcrumbs :items="breadcrumbs" />

    <div class="content">
      <rp-distributor-form
        @submit="updateUser"
        :genders="genders"
        :statuses="statuses"
        :roles="roles"
        v-model="form"/>

      <terms />
      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction" />
      </rp-overlay>
    </div>
  </section>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import DistributorForm from 'raypro_ui/src/components/ui/forms/Distributor'
  import {getAvailableRoles, deactivateUser, activateUser, getUserDetails, updateDistributor} from 'raypro_ui/src/api/users'
  import Terms from '@/components/Terms'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import page from '@/mixins/page'

  export default {
    data() {
      return {
        errors: {},
        form: {},
        roles: [],
        genders: [
          {'label': 'Male', 'value': 'M'},
          {'label': 'Female', 'value': 'F'},
          {'label': 'Prefer not to say', 'value': 'O'}
        ],
        status: '',
        statuses: [
          {label: 'Active', 'value': 'active'},
          {label: 'Inactive', 'value': 'inactive'}
        ],
        active: false,
        successMessage: 'Distributor updated successfully!',
        title: 'Edit distributor',
        breadcrumbs: [
          {
            label: 'Distributors',
            link: 'all-users'
          },
          {label: 'Edit distributor'}
        ]
      }
    },

    mixins: [page],

    mounted() {
      this.getRoles()
      this.getUser()
    },

    computed: {
      distributorPayload() {
        const form = this.form

        const distributor = {
          distributor: {
            status: form.status,
            profile: {
              last_name: form.last_name,
              gender: form.gender,
              first_name: form.first_name,
            },
            locale_id: form.locale_id,
            email: form.email,
            countries: form.countries.map((country) => { return country.id })
          }
        }

        return distributor
      }
    },

    props: {id: String},

    components: {
      'rp-distributor-form': DistributorForm,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      Breadcrumbs,
      Terms
    },

    methods: {
      successFunction() {
        this.$router.push({name: 'all-users', params: {role: 'rayner-distributor'}})
      },

      getRoles() {
        getAvailableRoles().then(({data}) => {
          this.roles = data.available_roles.map((role) => {
            return {key: role.name, value: role.id}
          })
        })
      },

      getUser() {
        getUserDetails(this.id).then(({data}) => {
          this.status = data.activated_at ? 'active' : 'inactive'

          this.form = {
            email: data.email,
            role: data.roles[0].id,
            first_name: data.profile.first_name,
            last_name: data.profile.last_name,
            gender: data.profile.gender,
            dob: data.profile.dob,
            status: data.activated_at ? 'active' : 'inactive',
            countries: data.countries
          }
        })
      },

      updateUser() {
        const formStatus = this.distributorPayload.distributor.status

        if(formStatus === 'active') {
          activateUser({id: this.id})
            .then(() => {
              this.activeOverlay = true
            })
            .catch(({response}) => {
              this.errors = response.errors
            })
        } else {
          deactivateUser({id: this.id})
            .then(() => {
              this.activeOverlay = true
            })
            .catch(({response}) => {
              this.errors = response.errors
            })
        }

        updateDistributor(this.id, this.distributorPayload)
          .then(() => {
            this.active = true
          })
          .catch(({response}) => {
            this.errors = response.errors
          })
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/pages/Distributors/EditDistributor.vue